// extracted by mini-css-extract-plugin
export var blockedMessage = "_87-3";
export var blockedOverlay = "_87-1";
export var fadeIn = "_87-2";
export var hereLink = "_87-0";
export var slideUp = "_87-4";